import api from '../../config/axiosConfig';
import React, { useState, useEffect, useCallback, useContext } from "react";
import "./ClientesAdmin.css";
import { AuthContext } from "../../context/AuthContext";

const ClientesAdmin = () => {
  const { token } = useContext(AuthContext);
  const [tab, setTab] = useState("listado");
  const [showVentaModal, setShowVentaModal] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [potenciales, setPotenciales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buscarDNI, setBuscarDNI] = useState("");
  const [buscarNombre, setBuscarNombre] = useState("");
  const [dni, setDni] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState("DNI");
  const [estado, setEstado] = useState("");
  const [obs, setObs] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [currentPagePotenciales, setCurrentPagePotenciales] = useState(1);
  const [totalPagesPotenciales, setTotalPagesPotenciales] = useState(1);
  const [totalRegistrosPotenciales, setTotalRegistrosPotenciales] = useState(0);


  const fetchClientes = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        pagina: currentPage,
        pageSize: 20,
        dni: buscarDNI,
        nombre: buscarNombre,
      };

      const response = await api.get("/clientes", {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      setClientes(response.data.clientes || []);
      setTotalPages(response.data.totalPaginas || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
    } catch (err) {
      console.log("Error al cargar clientes", err);
      setError("Error al cargar clientes");
      setClientes([]);
    } finally {
      setLoading(false);
    }
  }, [token, currentPage, buscarDNI, buscarNombre]);

  const fetchPotenciales = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        pagina: currentPagePotenciales,
        pageSize: 20,
        dni: buscarDNI,
        nombre: buscarNombre,
      };

      const response = await api.get("/clientes/potenciales",
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        }
      );

      setPotenciales(response.data.potenciales || []);
      setTotalPagesPotenciales(response.data.totalPaginas || 1);
      setTotalRegistrosPotenciales(response.data.totalRegistros || 0);
    } catch (err) {
      console.log("Error al cargar potenciales clientes", err);
      setError("Error al cargar potenciales clientes");
      setPotenciales([]);
    } finally {
      setLoading(false);
    }
  }, [token, currentPagePotenciales, buscarDNI, buscarNombre]);

  useEffect(() => {
  if (tab === "listado") {
    fetchClientes();
  } else if (tab === "potenciales") {
    fetchPotenciales();
  }
}, [tab, fetchClientes, fetchPotenciales]);

  const handleVenta = (cliente) => {
    setSelectedCliente(cliente);
    setDni(cliente.dni || "");
    setTipoDocumento(cliente.tipo_documento || "DNI");
    setEstado("");
    setObs("");
    setError("");
    setSuccess("");
    setShowVentaModal(true);
  };

  const handleGrabar = async () => {
    setError("");
    setSuccess("");

    if (!dni || !estado) {
      setError("Número de documento y Estado son obligatorios");
      return;
    }

    if (
      estado === "VENTA" &&
      selectedCliente.dni &&
      dni !== selectedCliente.dni
    ) {
      setError(
        "El número de documento ingresado no coincide con el registrado"
      );
      return;
    }

    try {
      await api.post("/clientes/potenciales/actualizar",
        {
          clienteId: selectedCliente.id,
          dni: dni,
          tipo_documento: tipoDocumento,
          estado: estado,
          observaciones: obs,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setSuccess("Cliente actualizado correctamente");
      setShowVentaModal(false);

      if (estado === "VENTA") {
        alert(
          "Abrir vista de Nueva Venta con datos: " +
          selectedCliente.nombres +
          " " +
          selectedCliente.apellidos
        );
      }

      fetchPotenciales();
    } catch (err) {
      console.log("Error al actualizar cliente", err);
      setError("Error al actualizar cliente");
    }
  };

  return (
    <div className="clientes-admin-outer">
      <div className="clientes-admin-header">
        <div className="clientes-admin-title">Clientes</div>
        <div className="clientes-admin-subtitle">
          Gestión profesional de clientes
        </div>
        <div className="clientes-admin-tabs">
          <button
            className={tab === "listado" ? "active" : ""}
            onClick={() => setTab("listado")}
          >
            Listado de Clientes
          </button>
          <button
            className={tab === "potenciales" ? "active" : ""}
            onClick={() => setTab("potenciales")}
          >
            Potenciales Clientes
          </button>
        </div>
      </div>

      <div className="clientes-admin-tab-content">
        {tab === "listado" && (
          <div className="clientes-table-container">
            <div className="clientes-table-header">
              <h2 className="clientes-table-title">Lista de Clientes</h2>
            </div>

            {/* Filtros de búsqueda */}
            <div className="usuarios-filtros">
              <div className="filtro-item">
                <label htmlFor="numero">Número de Documento:</label>
                <input
                  type="text"
                  value={buscarDNI}
                  onChange={(e) => setBuscarDNI(e.target.value)}
                  placeholder="Ingrese Número"
                />
              </div>
              <div className="filtro-item">
                <label htmlFor="buscar-nombre">Buscar por Nombre:</label>
                <input
                  type="text"
                  value={buscarNombre}
                  onChange={(e) => setBuscarNombre(e.target.value)}
                  placeholder="Ingrese nombre del cliente"
                  style={{
                    padding: "8px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "14px",
                  }}
                />
              </div>
              <div className="filtro-item">
                <button onClick={fetchClientes} className="btn-filtrar">
                  Buscar
                </button>
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            {(() => {
              if (loading) return <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>Cargando clientes...</div>;
              if (clientes.length === 0) return <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>No hay clientes registrados</div>;
              return (
              <>
                <div className="clientes-table-wrapper">
                  <table className="clientes-table">
                    <thead>
                      <tr>
                        <th>Tipo de Documento</th>
                        <th>Número</th>
                        <th>Nombres</th>
                        <th>Teléfono</th>
                        <th>Correo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clientes.map((cliente) => (
                        <tr key={cliente.id}>
                          <td>{cliente.tipo_documento}</td>
                          <td>{cliente.numero_documento}</td>
                          <td>
                            {cliente.numero_documento === "1"
                              ? `${cliente.nombres} ${cliente.apellidos}`
                              : cliente.razon_social}
                          </td>
                          <td>{cliente.telefono}</td>
                          <td>{cliente.email}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <span
                  style={{
                    marginLeft: "12px",
                    fontSize: "14px",
                    color: "#555",
                  }}
                >
                  {" "}
                  Total de registros: {totalRegistros}{" "}
                </span>
                <div className="pagination">
                  <button
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                  <span>
                    Página {currentPage} de {totalPages}
                  </span>

                  <button
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Siguiente
                  </button>
                </div>
              </>
            );
            })()}
          </div>
        )}

        {tab === "potenciales" && (
          <div className="clientes-table-container">
            <div className="clientes-table-header">
              <h2 className="clientes-table-title">Potenciales Clientes</h2>
            </div>

            {/* Filtros de búsqueda */}
            <div className="usuarios-filtros">
              <div className="filtro-item">
                <label htmlFor="numero-ponteciales">Número de Documento:</label>
                <input
                  type="text"
                  value={buscarDNI}
                  onChange={(e) => setBuscarDNI(e.target.value)}
                  placeholder="Ingrese DNI del cliente"
                />
              </div>
              <div className="filtro-item">
                <label htmlFor="nombre-potenciales">Buscar por Nombre:</label>
                <input
                  type="text"
                  value={buscarNombre}
                  onChange={(e) => setBuscarNombre(e.target.value)}
                  placeholder="Ingrese nombre del cliente"
                />
              </div>
              <div className="filtro-grupo">
                <button
                  onClick={fetchPotenciales}
                  className="btn-filtrar"
                >
                  Buscar
                </button>
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            {(() => {
              if (loading) return <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>Cargando potenciales clientes...</div>;
              if (potenciales.length === 0) return <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>No hay potenciales clientes</div>;
              return (
              <>
                <table className="clientes-table">
                  <thead>
                    <tr>
                      <th>Nombres</th>
                      <th>Apellidos</th>
                      <th>Tipo de Documento</th>
                      <th>Número de Documento</th>
                      <th>Teléfono</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {potenciales.map((cliente) => (
                      <tr key={cliente.id}>
                        <td>{cliente.nombre}</td>
                        <td>{cliente.apellidos}</td>
                        <td>{cliente.tipo_documento || "DNI"}</td>
                        <td>{cliente.numero_documento}</td>
                        <td>{cliente.telefono}</td>
                        <td>
                          <button
                            className="btn-venta"
                            onClick={() => handleVenta(cliente)}
                          >
                            VENTA
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <span
                  style={{
                    marginLeft: "12px",
                    fontSize: "14px",
                    color: "#555",
                  }}
                >
                  {" "}
                  Total de registros: {totalRegistrosPotenciales}{" "}
                </span>
                <div className="pagination">
                  <button
                    onClick={() => setCurrentPagePotenciales(currentPagePotenciales - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                  <span>
                    Página {currentPagePotenciales} de {totalPagesPotenciales}
                  </span>

                  <button
                    onClick={() => setCurrentPagePotenciales(currentPagePotenciales + 1)}
                    disabled={currentPagePotenciales === totalPagesPotenciales}
                  >
                    Siguiente
                  </button>
                </div>
              </>
            );
            })()}
          </div>
        )}
      </div>

      {showVentaModal && (
        <div className="sub-card-overlay">
          <div className="sub-card">
            <div className="sub-card-header">
              <h3>Registrar Venta</h3>
              <button
                className="sub-card-close"
                onClick={() => setShowVentaModal(false)}
              >
                ×
              </button>
            </div>

            <div className="sub-card-content">
              <div className="cliente-info">
                <div className="info-row">
                  <span className="info-label">Cliente:</span>
                  <span className="info-value">
                    {selectedCliente.nombres} {selectedCliente.apellidos}
                  </span>
                </div>
                <div className="info-row">
                  <span className="info-label">Teléfono:</span>
                  <span className="info-value">{selectedCliente.telefono}</span>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="tipo-documento">Tipo de Documento:</label>
                <select
                  value={tipoDocumento}
                  onChange={(e) => setTipoDocumento(e.target.value)}
                  className="sub-card-select"
                >
                  <option value="DNI">DNI</option>
                  <option value="CE">CE</option>
                  <option value="PASAPORTE">PASAPORTE</option>
                  <option value="OTRO">OTRO</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="numero-documento">Número de Documento:</label>
                <input
                  type="text"
                  value={dni}
                  onChange={(e) => setDni(e.target.value)}
                  placeholder="Ingrese número de documento"
                  className="sub-card-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="estado">Estado:</label>
                <select
                  value={estado}
                  onChange={(e) => setEstado(e.target.value)}
                  className="sub-card-select"
                >
                  <option value="">Seleccionar estado</option>
                  <option value="VENTA">VENTA</option>
                  <option value="NO DESEA">NO DESEA</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="observaciones">Observaciones:</label>
                <textarea
                  value={obs}
                  onChange={(e) => setObs(e.target.value)}
                  placeholder="Observaciones adicionales..."
                  className="sub-card-textarea"
                  rows="3"
                />
              </div>

              {error && <div className="sub-card-error">{error}</div>}
              {success && <div className="sub-card-success">{success}</div>}
            </div>

            <div className="sub-card-actions">
              <button
                className="sub-card-btn sub-card-btn-secondary"
                onClick={() => setShowVentaModal(false)}
              >
                Cancelar
              </button>
              <button
                className="sub-card-btn sub-card-btn-primary"
                onClick={handleGrabar}
              >
                Grabar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientesAdmin;
